import { Popover, Transition } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/solid';
import { EllipsisVerticalIcon } from '@heroicons/react/24/solid';
import { useLocation } from '@reach/router';
import { Link } from 'gatsby';
import React from 'react';
import { event } from '../../../lib/gtag';
import MagnifyingGlass from '../../atoms/magnifying-glass';
import RicohLogo from '../../atoms/ricoh-logo/ricoh-logo';
import GlobalNavigation from '../global-navigation';
import MobileNavigation from '../mobile-navigation';
import SiteSearch from '../site-search';
import * as Styles from './header.module.scss';

interface Props {
  className?: string;
}

const Header: React.FC<Props> = ({ className }) => {
  const location = useLocation();
  const [openSearch, setOpenSearch] = React.useState(false);

  return (
    <div
      className={`sticky top-0 z-50 bg-white text-lsGray-700 ${Styles.header} ${className}`}
    >
      <div className='flex items-center justify-between p-4 lg:px-6 lg:py-5'>
        <div className='flex items-center'>
          {location.pathname !== '/' && (
            <MobileNavigation className='mr-4 lg:mr-6 xl:hidden' />
          )}
          <Link className='flex items-center' to='/'>
            <RicohLogo color='#383838' className='w-16 lg:w-24' />
            <div className='ml-6 flex flex-col lg:ml-4'>
              <h5 className='font-roboto text-sm font-bold lg:text-lg'>
                4K Live Streaming
              </h5>
              <small className='font-roboto text-xs font-medium text-lsGray-400 lg:text-sm'>
                Developer
              </small>
            </div>
          </Link>
        </div>
        <GlobalNavigation
          openSearch={openSearch}
          setOpenSearch={setOpenSearch}
          className='hidden lg:block'
        />
        <div className='flex lg:hidden'>
          <MagnifyingGlass
            onClick={() => {
              event('click_search');
              setOpenSearch(!openSearch);
            }}
          />
          <Popover className='flex items-center'>
            <Popover.Button className='ml-4 backdrop-blur'>
              <EllipsisVerticalIcon className='h-8 w-8' />
            </Popover.Button>
            <Transition.Root>
              <Popover.Overlay className='fixed inset-0 z-50 bg-lsGray-900 bg-opacity-40' />
              <Popover.Panel
                focus
                className='fixed inset-x-0 top-0 z-50 origin-top bg-white'
              >
                {({ close }) => (
                  <>
                    <div className='flex flex-row-reverse justify-between'>
                      <Popover.Button aria-label='Close menu'>
                        <XMarkIcon className='mx-4 my-3 h-8 w-8' />
                      </Popover.Button>
                    </div>
                    <GlobalNavigation
                      openSearch={openSearch}
                      setOpenSearch={setOpenSearch}
                      close={close}
                    />
                  </>
                )}
              </Popover.Panel>
            </Transition.Root>
          </Popover>
        </div>
      </div>
      <SiteSearch open={openSearch} setOpen={setOpenSearch} />
    </div>
  );
};

Header.displayName = 'Header';

export default Header;
